var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"h6 mb-2"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"ma-0 pa-0 grey--text text--darken-1 text-body-2"},[_vm._v("\n    "+_vm._s(_vm.description)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }